export default {"src":"/_next/static/media/isd-logo-primary-light.be660609.svg","height":426,"width":440,"blurWidth":0,"blurHeight":0};